import type {
  CreateMailroomRequest,
  Mailroom,
  MailroomArrayResponse,
  MailroomResponse,
  UpdateMailroomRequest,
} from '@apiContract';

import { receivedDigitalApi } from './index';

const mailroomApi = receivedDigitalApi.injectEndpoints({
  endpoints: (builder) => ({
    getMailroom: builder.query<Mailroom, void>({
      query: () => 'Mailroom',
      providesTags: ['Mailroom'],
      transformResponse: (response: MailroomArrayResponse) => response.objectData[0],
    }),
    getMailRoomById: builder.query<Mailroom, number>({
      query: (id: number) => `Mailroom/${id}`,
      providesTags: ['Mailroom'],
      transformResponse: (response: MailroomResponse) => response.objectData,
    }),
    createMailroom: builder.mutation<Mailroom, CreateMailroomRequest>({
      query: (requestData) => ({
        url: 'Mailroom',
        method: 'POST',
        body: requestData,
      }),
      invalidatesTags: ['Mailroom'],
      transformResponse: (response: MailroomResponse) => response.objectData,
    }),

    updateMailroom: builder.mutation<Mailroom, UpdateMailroomRequest>({
      query: (requestData) => ({
        url: 'Mailroom',
        method: 'PUT',
        body: requestData,
      }),
      invalidatesTags: ['Mailroom'],
      transformResponse: (response: MailroomResponse) => response.objectData,
    }),
  }),
});

export const { useGetMailroomQuery, useGetMailRoomByIdQuery, useCreateMailroomMutation, useUpdateMailroomMutation } = mailroomApi;
